/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_login_layout_carousel_title_2 = /** @type {(inputs: {}) => string} */ () => {
	return `Contrata Empleados y Automatiza sus Pagos.`
};

const en_login_layout_carousel_title_2 = /** @type {(inputs: {}) => string} */ () => {
	return `Hire Employees and Automate their Payments.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const login_layout_carousel_title_2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.login_layout_carousel_title_2(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("login_layout_carousel_title_2", locale)
	if (locale === "es") return es_login_layout_carousel_title_2(inputs)
	return en_login_layout_carousel_title_2(inputs)
};
export { login_layout_carousel_title_2 as "login_layout.carousel.title_2" }